"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return target;
};
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step2;
    try {
      var _loop = function _loop() {
        var key = _step2.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return to;
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// src/index.ts
var src_exports = {};
__export(src_exports, {
  KEY_RESET_NODE: function KEY_RESET_NODE() {
    return _KEY_RESET_NODE;
  },
  SIMULATE_BACKSPACE: function SIMULATE_BACKSPACE() {
    return _SIMULATE_BACKSPACE;
  },
  createResetNodePlugin: function createResetNodePlugin() {
    return _createResetNodePlugin;
  },
  onKeyDownResetNode: function onKeyDownResetNode() {
    return _onKeyDownResetNode;
  }
});
module.exports = __toCommonJS(src_exports);

// src/createResetNodePlugin.ts
var import_server2 = require("@udecode/plate-common/server");
var import_slate = require("slate");

// src/onKeyDownResetNode.ts
var import_server = require("@udecode/plate-common/server");
var _SIMULATE_BACKSPACE = {
  key: "",
  which: 8
};
var _onKeyDownResetNode = function _onKeyDownResetNode(editor, _ref) {
  var rules = _ref.options.rules;
  return function (event) {
    if (event.defaultPrevented) return;
    var reset;
    if (!editor.selection) return;
    if ((0, import_server.isCollapsed)(editor.selection)) {
      rules.forEach(function (_ref2) {
        var defaultType = _ref2.defaultType,
          hotkey = _ref2.hotkey,
          onReset = _ref2.onReset,
          predicate = _ref2.predicate,
          types = _ref2.types;
        var _a;
        if (hotkey && (0, import_server.isHotkey)(hotkey, event) && predicate(editor) && (0, import_server.someNode)(editor, {
          match: {
            type: types
          }
        })) {
          (_a = event.preventDefault) == null ? void 0 : _a.call(event);
          (0, import_server.setElements)(editor, {
            type: defaultType
          });
          if (onReset) {
            onReset(editor);
          }
          reset = true;
        }
      });
    }
    return reset;
  };
};

// src/createResetNodePlugin.ts
var _KEY_RESET_NODE = "resetNode";
var _createResetNodePlugin = (0, import_server2.createPluginFactory)({
  handlers: {
    onKeyDown: _onKeyDownResetNode
  },
  key: _KEY_RESET_NODE,
  options: {
    rules: []
  },
  withOverrides: function withOverrides(editor, _ref3) {
    var options = _ref3.options;
    var deleteBackward = editor.deleteBackward,
      deleteFragment = editor.deleteFragment;
    if (!options.disableEditorReset) {
      var deleteFragmentPlugin = function deleteFragmentPlugin() {
        var selection = editor.selection;
        if (!selection) return;
        var start = (0, import_server2.getStartPoint)(editor, []);
        var end = (0, import_server2.getEndPoint)(editor, []);
        if (import_slate.Point.equals(selection.anchor, start) && import_slate.Point.equals(selection.focus, end) || import_slate.Point.equals(selection.focus, start) && import_slate.Point.equals(selection.anchor, end)) {
          (0, import_server2.resetEditorChildren)(editor, {
            insertOptions: {
              select: true
            }
          });
          return true;
        }
      };
      editor.deleteFragment = function (direction) {
        if (deleteFragmentPlugin()) return;
        deleteFragment(direction);
      };
    }
    if (!options.disableFirstBlockReset) {
      editor.deleteBackward = function (unit) {
        var selection = editor.selection;
        if (selection && (0, import_server2.isCollapsed)(selection)) {
          var start = (0, import_server2.getStartPoint)(editor, []);
          if (import_slate.Point.equals(selection.anchor, start)) {
            var node = (0, import_server2.getNode)(editor, [0]);
            var _a = editor.blockFactory({}, [0]),
              children = _a.children,
              props = __objRest(_a, ["children"]);
            (0, import_server2.withoutNormalizing)(editor, function () {
              var _a2 = (0, import_server2.getNodeProps)(node),
                id = _a2.id,
                nodeProps = __objRest(_a2, ["id"]);
              (0, import_server2.unsetNodes)(editor, Object.keys(nodeProps), {
                at: [0]
              });
              (0, import_server2.setNodes)(editor, props, {
                at: [0]
              });
            });
            return;
          }
        }
        deleteBackward(unit);
      };
    }
    return editor;
  }
});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  KEY_RESET_NODE: _KEY_RESET_NODE,
  SIMULATE_BACKSPACE: _SIMULATE_BACKSPACE,
  createResetNodePlugin: _createResetNodePlugin,
  onKeyDownResetNode: _onKeyDownResetNode
});